import classnames from "classnames";
import React, { useMemo } from "react";
import icBeneficios from "../../../assets/icons/ic-beneficios.svg";
import icCoberturasAdicionales from "../../../assets/icons/ic-coberturas-adicionales.svg";
import icCoberturas from "../../../assets/icons/ic-coberturas.svg";
import icSeguroObligatorio from "../../../assets/icons/ic-seguro-obligatorio.svg";
import { ConstrainedBox } from "../../../components/layout/constrained-box";
import { FlexLayout, Row } from "../../../components/layout/flex-layout";
import { SpacingBox } from "../../../components/layout/spacing-box";
import { Typography } from "../../../components/typography/typography";
import { useWindowResize } from "../../../hooks/use-windows-resize";

const commonBenefits = [
    {
        img: (
            <img
                src={icSeguroObligatorio}
                width={40}
                alt="seguro obligatorio"
            />
        ),
        content: (
            <p>
                <b>Seguro obligatorio</b> para todos tus trabajadores desde el
                primer día de relación laboral
            </p>
        ),
    },
    {
        img: <img src={icCoberturas} width={40} alt="seguro obligatorio" />,
        content: (
            <p>
                <b>Coberturas:</b> Muerte natural (16 remuneraciones mensuales),
                Muerte accidental o Invalidez total y permanente por accidente
                (32 remuneraciónes mensuales)
            </p>
        ),
    },
    {
        img: (
            <img
                src={icCoberturasAdicionales}
                width={40}
                alt="seguro obligatorio"
            />
        ),
        content: (
            <p>
                <b>Coberturas adicionales:</b>{" "}
                <a
                    href={process.env.REACT_APP_COBERTURAS_ADICIONALES_PDF_URL}
                    target="_blank"
                    rel="noreferrer noopener"
                >
                    <Typography variant="secondary" decoration="underline">
                        Conoce más aquí
                    </Typography>
                </a>
            </p>
        ),
    },
    {
        img: <img src={icBeneficios} width={40} alt="seguro obligatorio" />,
        content: (
            <p>
                <b>Beneficios Vida Ley:</b>{" "}
                <a
                    href={process.env.REACT_APP_BENEFICIOS_PDF_URL}
                    target="_blank"
                    rel="noreferrer noopener"
                >
                    <Typography variant="secondary" decoration="underline">
                        Conoce más aquí*
                    </Typography>
                </a>
            </p>
        ),
    },
];

const desktopBenefits = [
    {
        img: commonBenefits[0].img,
        content: (
            <ConstrainedBox maxWidth={232}>
                {commonBenefits[0].content}
            </ConstrainedBox>
        ),
    },
    {
        img: commonBenefits[1].img,
        content: (
            <ConstrainedBox maxWidth={254}>
                {commonBenefits[1].content}
            </ConstrainedBox>
        ),
    },
    {
        img: commonBenefits[2].img,
        content: (
            <ConstrainedBox maxWidth={190}>
                {commonBenefits[2].content}
            </ConstrainedBox>
        ),
    },
    {
        img: commonBenefits[3].img,
        content: (
            <ConstrainedBox maxWidth={162}>
                {commonBenefits[3].content}
            </ConstrainedBox>
        ),
    },
];

export const LandingBenefitsSection = () => {
    const { isMobile } = useWindowResize();
    const benefits = useMemo(
        () => (isMobile ? commonBenefits : desktopBenefits),
        [isMobile]
    );
    return (
        <div
            data-testid="LandingBenefitsSection"
            className={classnames("landing-benefits-section", {
                "landing-benefits-section--desktop": !isMobile,
            })}
        >
            <FlexLayout
                as="ul"
                direction={isMobile ? "column" : "row"}
                align={isMobile ? "flex-start" : "center"}
                justify={isMobile ? "flex-start" : "center"}
            >
                {benefits.map((b, i) => (
                    <li key={i}>
                        <SpacingBox ml={i === 0 || isMobile ? 0 : 36}>
                            <Row align={isMobile ? "center" : "flex-start"}>
                                {b.img}
                                <Typography fontSize={isMobile ? 14 : 15}>
                                    <SpacingBox ml={15}>{b.content}</SpacingBox>
                                </Typography>
                            </Row>
                        </SpacingBox>
                    </li>
                ))}
            </FlexLayout>
        </div>
    );
};
